<template>
  <div class="home">
    <el-row :gutter="20" v-if="show.showStatistic">
      <el-col :span="16">
        <el-card class="chart-card" shadow="hover">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form :inline="true" style="height: 50px;">
                <el-form-item :label="util.language('时间段', 'Time range')">
                  <el-date-picker size="small" :clearable="false" v-model="statisticParam.dates" @change="resetStatistic" type="daterange" style="width: 200px;" />
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="6">
              <el-statistic :precision="0" :value="statisticResult.selectionOrder.orderCount">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    <el-text>{{ util.language('订单数', 'Order count') }}</el-text>
                  </div>
                </template>
                <template #suffix>
                  <el-text>{{ util.language('笔', 'order(s)') }}</el-text>
                </template>
              </el-statistic>
            </el-col>
            <el-col :span="6">
              <el-statistic :precision="2" :value="statisticResult.selectionOrder.finalAmount">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    <el-text>{{ util.language('订单金额', 'Order amount') }}</el-text>
                  </div>
                </template>
                <template #suffix>
                  <el-text>{{ 'CAD' }}</el-text>
                </template>
              </el-statistic>
            </el-col>
            <el-col :span="6">
              <el-statistic :precision="2" :value="statisticResult.selectionOrder.totalProfit">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    <el-text>{{ util.language('利润', 'Profit') }}</el-text>
                  </div>
                </template>
                <template #suffix>
                  <el-text>{{ 'CAD' }}</el-text>
                </template>
              </el-statistic>
            </el-col>
            <el-col :span="6">
              <el-statistic :precision="2" :value="statisticResult.selectionOrder.profitRate">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    <el-text>{{ util.language('利润率', 'Profit rate') }}</el-text>
                  </div>
                </template>
                <template #suffix>
                  <el-text>{{ '%' }}</el-text>
                </template>
              </el-statistic>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="chart-card" shadow="hover">
          <el-col :span="24">
            <el-form :inline="true" style="height: 50px;">
              <el-form-item :label="util.language('当前未完成', 'Unfinished')">
              </el-form-item>
            </el-form>
          </el-col>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-statistic :precision="0" :value="statisticResult.unfinishedOrder.orderCount">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    <el-text>{{ util.language('订单数', 'Order count') }}</el-text>
                  </div>
                </template>
                <template #suffix>
                  <el-text>{{ util.language('笔', 'order(s)') }}</el-text>
                </template>
              </el-statistic>
            </el-col>
            <el-col :span="12">
              <el-statistic :precision="2" :value="statisticResult.unfinishedOrder.finalAmount">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    <el-text>{{ util.language('订单金额', 'Order amount') }}</el-text>
                  </div>
                </template>
                <template #suffix>
                  <el-text>{{ 'CAD' }}</el-text>
                </template>
              </el-statistic>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24">
        <el-card class="chart-card" shadow="hover">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-text>{{ util.language('当前库存', 'Current inventory') }}</el-text>
            </el-col>
            <el-col :span="8" style="text-align: center;">
              <el-statistic :precision="0" :value="statisticResult.totalPieceInventoryQuantity">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    <el-text>{{ util.language('数量', 'Quantity') }}</el-text>
                  </div>
                </template>
                <template #suffix>
                  <el-text>{{ util.language('件', 'piece(s)') }}</el-text>
                </template>
              </el-statistic>
            </el-col>
            <el-col :span="8" style="text-align: center;">
              <el-statistic :precision="2" :value="statisticResult.totalInventoryValue">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    <el-text>{{ util.language('货值', 'Value') }}</el-text>
                  </div>
                </template>
                <template #suffix>
                  <el-text>{{ 'CAD' }}</el-text>
                </template>
              </el-statistic>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-table :data="statisticResult.productType" style="width: 100%; height: calc(100vh - 380px);">
              <el-table-column align="center" prop="enName" />
              <el-table-column align="center" prop="totalPieceInventoryQuantity" />
              <el-table-column align="center" prop="totalInventoryValue" />
            </el-table>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-else>
      <h1 style="text-align: center; width: 100%;">
        {{ util.language('你好，', 'Hi, ') }}
        {{ show.userInfo.nick }}
        {{ util.language('。欢迎访问Ocean Trader Sales System。', '. Welcome to Ocean Trader Sales System.') }}
      </h1>
      <el-col :span="24">
        <el-empty :description="util.language('您无权限查看统计数据', 'You do not have permission to view statistical data')" />
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import math from '../../utils/math'
import api from '../../apis/api'
import cache from '../../utils/cache'
import * as echarts from 'echarts'
import util from '../../utils/util'

const shopId = cache.getString(cache.keys.shopId) * 1
if (!shopId) {
  ElMessage.error(util.language('请先选择店铺', 'Please select a shop first'))
}

const show = reactive({
  userInfo: {},
  showStatistic: false,
})

let now = new Date()
let lastMonth = new Date()
lastMonth.setMonth(lastMonth.getMonth() - 1)


const statisticParam = reactive({
  dates: [lastMonth, now]
})
const statisticResult = reactive({
  totalPieceInventoryQuantity: 0,
  totalInventoryValue: 0,
  productType: [],
  selectionOrder: {
    orderCount: 0,
    finalAmount: 0,
    totalProfit: 0,
    profitRate: 0, // 利润率，百分比值
  },
  unfinishedOrder: {
    orderCount: 0,
    finalAmount: 0,
  },
})
const resetStatistic = () => {
  if (!statisticParam.dates || statisticParam.dates.length < 2) {
    return
  }
  api.get('/backend/statistics/index', {
    params: {
      shopId: shopId,
      datetimeGe: statisticParam.dates[0].getTime(),
      datetimeLt: statisticParam.dates[1].getTime() + 24 * 60 * 60 * 1000,
    }
  }).then(res => {
    let profitRate = 0
    if (res.selectionOrder.finalAmount != 0) {
      profitRate = math.halfUp(math.multiply(math.divide(res.selectionOrder.totalProfit, res.selectionOrder.finalAmount), 100), 2)
    }
    res.selectionOrder.profitRate = profitRate
    statisticResult.totalPieceInventoryQuantity = res.totalPieceInventoryQuantity
    statisticResult.totalInventoryValue = res.totalInventoryValue
    statisticResult.productType = res.productType
    statisticResult.selectionOrder = res.selectionOrder
    statisticResult.unfinishedOrder = res.unfinishedOrder
  })
}

onMounted(() => {
  api.get('/backend/user/getMyInfo').then(res => {
    show.userInfo = res
    if (res.admin || res.role.menuList.filter(menu => menu == 'home').length > 0) {
      show.showStatistic = true
      resetStatistic()
    }
  })
})
</script>

<style lang="less">
.home {
  .chart-card {
    margin-bottom: 20px;
  }
}
</style>